const InfoCircleIcon = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 14 14" width="14" height="14">
    <path d="M7,14c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7s7,3.1,7,7C14,10.9,10.9,14,7,14z M7,1C3.7,1,1,3.7,1,7s2.7,6,6,6c3.3,0,6-2.7,6-6S10.3,1,7,1z" />
    <path d="M7,4.2c0.6,0,1.1-0.5,1.1-1.1C8.1,2.5,7.6,2,7,2S5.9,2.5,5.9,3.1C5.9,3.7,6.4,4.2,7,4.2z M6,11.2H8V5H6V11.2z" />
  </svg>
);

export default InfoCircleIcon;
